// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"849cd7a6","455":"36f88853","488":"59e159e5"}[chunkId] + ".chunk.js";
};